import { useEffect, useRef } from 'react';
import { useWatch } from 'react-hook-form';

/**
 * useAutoPreview — Envia patches automáticos ao iframe de preview (§9.2 do plano).
 *
 * Subscreve apenas os campos que disparam refresh automático (§9.2):
 *   templateId, layoutMode, customStyles, scope, blocks[]
 * Campos de texto livre (seo.*, scope.professionalId, etc.) são excluídos
 * intencionalmente — P15 proíbe refresh a cada keystroke.
 *
 * Debounce: 150ms. Se múltiplos campos mudarem juntos, só um patch é enviado.
 *
 * @param {object} form - instância do react-hook-form com siteFormSchema
 * @param {React.MutableRefObject} previewRef - ref expondo sendPatch() do SitePreview
 */
export default function useAutoPreview(form, previewRef) {
  const [templateId, layoutMode, customStyles, scope, blocks] = useWatch({
    control: form.control,
    // Blocks incluídos porque add/remove/toggle/reorder são mudanças estruturais (§9.2)
    name: ['templateId', 'layoutMode', 'customStyles', 'scope', 'blocks'],
  });

  const timerRef = useRef(null);

  useEffect(() => {
    clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      previewRef.current?.sendPatch({ templateId, layoutMode, customStyles, scope, blocks });
    }, 150);
    return () => clearTimeout(timerRef.current);
  }, [templateId, layoutMode, customStyles, scope, blocks]);
}

